/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
import React from 'react';

import { Text, View, Image } from '@react-pdf/renderer';
import SubLine from '../../createLine';
import { ChineseFonts, maintainRation, RationValHeight, RationValWidth } from '../../fonts/font';
import { styleflowsheet } from './flowsheet_design_style';
import DisplayTable from '../../displayTable';

const FlowsheetDesign = (props) => {
  const borderColor = '#002D62';
  const { pageWidth, tableWidth, flowSheetImage, invoiceData, langualgeCheck, translateObject } = props;
  let { serialNum, subSerialNum } = props;
  // const header = {
  //   'source': 'Source',
  //   'unit_op': 'Unit',
  //   'pump': 'Pump',
  //   'sink': 'Sink',
  //   'mixer_splitter': 'Mixer-Splitter'
  // };

  return (
    <View style={{ width: RationValWidth(pageWidth) }}>

      {/* <View style={[styleflowsheet.mainHeader, { width: RationValWidth(pageWidth) }]}>
        <Text style={langualgeCheck ? { fontFamily: ChineseFonts } : {}}>{serialNum}. {translateObject('Flowsheet Design Summary')}</Text>
        <SubLine lineWidth='57%' lineHeight='24' style={{ marginLeft: 5 }} />
      </View> */}
      <View style={[styleflowsheet.mainHeader, { width: RationValWidth(pageWidth) }]}>
        <Text style={langualgeCheck ? { fontFamily: ChineseFonts } : {}}>{serialNum}. {translateObject('Flowsheet Design Summary')}</Text>
        <SubLine lineWidth='57%' lineHeight='24' style={{ marginLeft: 5 }} />
      </View>
      {(() => {
        if (flowSheetImage) {
          let getHeight = '';
          if (flowSheetImage.height > 1250) {
            getHeight = maintainRation(1140, 1250, flowSheetImage.width, flowSheetImage.height);
          }
          return (
            <View style={{ marginTop: 15 }}>
              <View style={styleflowsheet.textHeader} bookmark={{ title: `${serialNum}.${subSerialNum} Flowsheet Design` }}>
                <Text style={{ paddingLeft: 0 }}>{serialNum}.{subSerialNum++}</Text>
                <Text style={{ paddingLeft: 5, ...(langualgeCheck && { fontFamily: ChineseFonts }) }}>{translateObject('Flowsheet Design')}</Text>
              </View>
              <View style={[
                getHeight ? { height: RationValHeight(getHeight.canHeight) } : {},
                {
                  width: RationValWidth(tableWidth),
                  margin: '0 auto',
                  border: 1,
                  borderRadius: 5,
                  borderColor
                }
              ]}>
                <Image src={flowSheetImage.src} alt="" />
              </View>
            </View>
          );
        }
      })()}

      {invoiceData.coverpage_dict && Object.keys(invoiceData.coverpage_dict).length > 0 && (
        <View>
          <DisplayTable
            langualgeCheck={langualgeCheck}
            translateObject={translateObject}
            serialNum={serialNum}
            subSerialNum={subSerialNum}
            invoice={invoiceData}
          />
        </View>
      )}
    </View>
  );
};
export default FlowsheetDesign;